import { createContext } from 'react';
var featureFlagContext = /*#__PURE__*/createContext(undefined);
export default featureFlagContext;